import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from '../AppIcon';

const DashboardQuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      label: 'Add Transaction',
      path: '/transactions-management',
      icon: 'Plus',
      variant: 'default',
      description: 'Record a new transaction'
    },
    {
      label: 'View Accounts',
      path: '/accounts-overview',
      icon: 'Wallet',
      variant: 'outline',
      description: 'Manage your accounts'
    },
    {
      label: 'Check Budget',
      path: '/budget-management',
      icon: 'Target',
      variant: 'outline',
      description: 'Review spending limits'
    }
  ];

  const handleAction = (action) => {
    if (action?.onClick) {
      action?.onClick();
    } else {
      navigate(action?.path);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-20">
      {quickActions?.map((action, index) => (
        <button
          key={action?.label}
          onClick={() => handleAction(action)}
          className={`
            bg-card rounded-xl p-20 md:p-24 border transition-all duration-200
            hover:shadow-md active:scale-[0.98] text-left group
            ${
              index === 0
                ? 'border-primary/30 hover:border-primary/50 shadow-sm'
                : 'border-border/50 hover:border-border'
            }
          `}
        >
          <div className="flex items-start gap-16 mb-12">
            <div className={`
              flex items-center justify-center w-12 h-12 rounded-lg transition-colors
              ${
                index === 0
                  ? 'bg-primary/10 group-hover:bg-primary/20' :'bg-muted group-hover:bg-muted/80'
              }
            `}>
              <Icon
                name={action?.icon}
                size={20}
                color={index === 0 ? 'var(--color-primary)' : 'var(--color-foreground)'}
                strokeWidth={2}
              />
            </div>
            <div className="flex-1">
              <h3 className={`text-base font-heading font-semibold mb-4 ${
                index === 0 ? 'text-foreground' : 'text-foreground'
              }`}>
                {action?.label}
              </h3>
              <p className="text-sm text-muted-foreground font-caption">
                {action?.description}
              </p>
            </div>
            <Icon
              name="ArrowRight"
              size={18}
              color="var(--color-muted-foreground)"
              className="opacity-0 group-hover:opacity-100 transition-opacity"
            />
          </div>
        </button>
      ))}
    </div>
  );
};

export default DashboardQuickActions;